export const project = require('./project-min.png');
export const ill1 = require('./ill1-min.png');
export const ill2 = require('./ill2-min.png');
export const ill3 = require('./ill3-min.png');
